import { getSchema, Schema } from '@lyearn/lygo-core';
import { getLyExtensions } from '@/lygo/AllExtensions';

type OptionsType = {
  isDefaultRestricted?: boolean;
  isMicroLearning?: boolean;
};
export default function getEditorSchema(
  extensions: Parameters<typeof getSchema>[0],
  options: OptionsType,
) {
  const lyExtensions = getLyExtensions({
    isDefaultRestricted: options?.isDefaultRestricted,
  });
  // @ts-ignore don't remove this ignore. it is flaky on different machines.
  const { nodes, marks, plugins, nodePerformanceMap, inputRules, markdownTokens } = getSchema([
    ...extensions,
    ...lyExtensions,
  ]);

  const editorSchema = new Schema({ marks, nodes });

  return {
    marks,
    nodes,
    schema: editorSchema,
    nodePerformanceMap,
    plugins,
    inputRules,
    markdownTokens,
  };
}
